import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import { AlertMessage, PasswordInput, Input } from 'shared/components';
import { ValidationService, UsersService } from 'shared/services';
import './NewPassword.scss';

class NewPassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      password: '',
      errorCode: [],
      verificationCode: '',
    };

    this.onChange = this.onChange.bind(this);
    this.onChangeValidationCode = this.onChangeValidationCode.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.setTimer = this.setTimer.bind(this);
    this.removeMessage = this.removeMessage.bind(this);
    this.onResendCode = this.onResendCode.bind(this);
  }

  componentDidMount() {
    this.setTimer();
  }

  onChange(e) {
    this.setState({
      password: e.target.value,
      errors: [],
    });
  }

  onChangeValidationCode(e) {
    const { value } = e.target;
    if (value.length > 6) {
      return;
    }
    this.setState({
      [e.target.name]: value,
    });
  }

  onSubmit(e) {
    e.preventDefault();
    const errors = [];
    const { password, verificationCode } = this.state;

    if (!password || !verificationCode) {
      errors.push('errors.passwordRequired');
      this.setState({
        errors: !password ? errors : [],
        errorCode: !verificationCode ? ['errors.codeRequired'] : [],
      });
      return;
    }

    const isValid = ValidationService.validPassword(this.state.password);

    if (!isValid || verificationCode.length < 6) {
      errors.push('errors.passwordInvalid');
      this.setState({
        errors: !isValid ? errors : [],
        errorCode: verificationCode.length < 6 ? ['errors.verifCodeLength'] : [],
      });
      return;
    }

    this.props.onSubmit(this.state.password, this.state.verificationCode);
  }

  onResendCode() {
    UsersService.forgotPassword(this.props.email)
      .then(() => {
        this.setTimer();
        this.setState({
          showMessage: true,
          showMessageTime: 3000,
        });
      })
      .catch((error) => {
        this.setState({
          errors: [error.data.Error],
        });
      });
  }

  setTimer() {
    const stopTime = moment().add(30, 's');
    const diff = moment(Math.ceil(stopTime.diff(moment())));
    this.setState({
      time: diff.format('ss'),
    });
    const interval = setInterval(() => {
      const diff = moment(Math.ceil(stopTime.diff(moment())));
      this.setState({
        time: diff.format('ss'),
      });
      if (diff.seconds() === 0) {
        clearInterval(interval);
        this.setState({
          time: null,
        });
      }
    }, 1000);
  }

  removeMessage() {
    this.setState({
      showMessage: false,
    });
  }

  render() {
    return (
      <div className="new-password-container">
        <h4 className="mb-3">{this.props.t('resetPassword.newPasswordTitle')}</h4>

        <form name="newPassword" onSubmit={this.onSubmit} noValidate>
          <div className="list-group-item">
            <div>
              <label
                className={`${this.state.errorCode ? 'label-error' : ''} w-50`}
                htmlFor="verificationCode">
                {this.props.t('register.validationCodeLabel')}
              </label>
              <div className="timer-container">
                {this.state.time ? (
                  <div className="d-block font-size-10">
                    {this.props.t('resetPassword.timerLabel', { time: this.state.time })}
                  </div>
                ) : (
                  <button type="button" className="btn-link" onClick={this.onResendCode}>
                    {this.props.t('resetPassword.resendCode')}
                  </button>
                )}
              </div>
            </div>
            <Input
              type="number"
              name="verificationCode"
              value={this.state.verificationCode}
              onChange={this.onChangeValidationCode}
              errors={this.state.errorCode}
              required
            />
          </div>
          <div>
            <label className="w-50" htmlFor="password">
              {this.props.t('resetPassword.newPasswordLabel')}
            </label>
            <PasswordInput
              value={this.state.password}
              errors={this.state.errors}
              onChange={this.onChange}
            />
          </div>
          {this.props.error && <p className="text-error text-small">{this.props.error}</p>}
          <button type="submit" className="btn btn-primary w-100 m-0">
            {this.props.t('resetPassword.changePassword')}
          </button>
          <AlertMessage
            show={this.state.showMessage}
            time={this.state.showMessageTime}
            removeMessage={this.removeMessage}
            message="resetPassword.successResendCode"
          />
        </form>
      </div>
    );
  }
}

NewPassword.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(NewPassword);
